import React from "react";
import { LevelInput } from "../../services/rubricAdminService";
import ExamplesEditor from "./ExamplesEditor";

interface Props {
  kind: "conversation" | "solution";
  rubricId: string;
  getToken: () => string | undefined;
  levels: LevelInput[];
  onChange: (next: LevelInput[]) => void;
}

const emptyLevel = (): LevelInput => ({
  name: "",
  minGrade: 0,
  maxGrade: 0,
  description: "",
  examples: [],
});

const PerformanceLevelsEditor: React.FC<Props> = ({
  kind,
  rubricId,
  getToken,
  levels,
  onChange,
}) => {
  const update = (i: number, patch: Partial<LevelInput>) =>
    onChange(levels.map((l, j) => (j === i ? { ...l, ...patch } : l)));

  return (
    <div className="mt-3">
      <div className="form-label">Performance levels</div>
      {levels.map((l, i) => (
        <div key={i} className="border border-outline-variant/30 rounded-md p-3 mt-2">
          <div className="flex gap-2">
            <input
              className="form-control flex-1"
              placeholder="Name"
              value={l.name}
              onChange={(e) => update(i, { name: e.target.value })}
            />
            <input
              className="form-control w-20"
              type="number"
              placeholder="Min"
              value={l.minGrade}
              onChange={(e) => update(i, { minGrade: Number(e.target.value) })}
            />
            <input
              className="form-control w-20"
              type="number"
              placeholder="Max"
              value={l.maxGrade}
              onChange={(e) => update(i, { maxGrade: Number(e.target.value) })}
            />
            <button
              type="button"
              className="text-error text-sm"
              onClick={() => onChange(levels.filter((_, j) => j !== i))}
            >
              Remove
            </button>
          </div>
          <textarea
            className="form-control h-16 mt-2 text-sm"
            placeholder="Description"
            value={l.description}
            onChange={(e) => update(i, { description: e.target.value })}
          />
          <textarea
            className="form-control h-16 mt-2 text-sm"
            placeholder="Grader instructions (optional)"
            value={l.instructions ?? ""}
            onChange={(e) => update(i, { instructions: e.target.value })}
          />
          <ExamplesEditor
            kind={kind}
            rubricId={rubricId}
            getToken={getToken}
            examples={l.examples}
            onChange={(examples) => update(i, { examples })}
          />
        </div>
      ))}
      <button
        type="button"
        className="text-sm text-slate-400 mt-2"
        onClick={() => onChange([...levels, emptyLevel()])}
      >
        + Add level
      </button>
    </div>
  );
};

export default PerformanceLevelsEditor;
